import React, { useEffect, useRef, useState } from 'react';
import Logo from '../Logo';
import './Header.css';

const Header = ({children}) => {
  const [openAside,setOpenAside]=useState(false);

  const [activeSection, setActiveSection] = useState('');
  const sectionsRef = useRef([]);

  const [copySuccess, setCopySuccess] = useState('');
  useEffect(() => {
    const handleScroll = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id); // Define a seção ativa
        }
      });
    };

    const observer = new IntersectionObserver(handleScroll, {
      threshold: 0.6, // Percentual de visibilidade para considerar a seção ativa
    });
    console.log(sectionsRef)
    sectionsRef.current.forEach((section) => observer.observe(section));

    return () => {
      sectionsRef.current.forEach((section) => observer.unobserve(section));
    };
  }, []);
    const nav = () => {
        return(
            <nav>
                <a onClick={()=>setOpenAside(false)} className={activeSection === 'structure-section' ? 'active' : ''} href={"#structure-section"}>Estrutura</a>
                <a onClick={()=>setOpenAside(false)} className={activeSection === 'equipment-section' ? 'active' : ''} href={"#equipment-section"}>Equipamentos</a>
                <a onClick={()=>setOpenAside(false)} className={activeSection === 'values-section' ? 'active' : ''}  href={"#values-section"}>Valores</a>
                {/* <a>Normas</a> */}
                <a onClick={()=>setOpenAside(false)} className={activeSection === 'gallery-section' ? 'active' : ''}  href={"#gallery-section"}>Galeria</a>
                <a onClick={()=>setOpenAside(false)} className={activeSection === 'contact-section' ? 'active' : ''}  href={"#contact-section"}>Contato</a>
            </nav>
        )
    }
    const handlerCopy = async (text) => {
          try {
              await navigator.clipboard.writeText(text);
              setCopySuccess('Copiado!');
              alert('Copiado!');
          } catch (err) {
              setCopySuccess('Erro ao copiar.');
          }
      
    }

    const scrollToNextSection = (index) => {
      const sections = sectionsRef.current;
      if (!sections || sections.length === 0) return;
    
      const nextIndex = (index + 1) % sections.length;
      const nextSection = sections[nextIndex];
    
      if (nextSection) {
        // Desativa o snap temporariamente
        document.documentElement.style.scrollSnapType = 'none';
    
        // Rola suavemente para a próxima seção
        nextSection.scrollIntoView({ behavior: 'smooth' });
    
        // Reativa o snap após a rolagem suave
        setTimeout(() => {
          document.documentElement.style.scrollSnapType = 'y mandatory'; // volta ao valor original do CSS
        }, 1000); // Ajuste o tempo conforme necessário
      }
    };
    return(
        <>
        <header>
            <Logo />
            <div>
                {nav()}
            </div>
            <div className='social-media'>
              <div className='social-wrapper'>
                <a href={'https://wa.me/5511950742962'} target={"_blank"}><i className='fa-brands fa-whatsapp'></i></a>
                <label>11 95074 2962</label>
              </div>
              <div className='divider'></div>
              <div className='social-wrapper'>
                <a href={'https://instagram.com/estudiozupa'} target={"_blank"}><i className='fa-brands fa-instagram'></i></a>
                <label>@estudiozupa</label>
              </div>
            </div>
            <button onClick={()=>setOpenAside(true)} id='menu'><div></div><div></div><div></div></button>
        </header>
        {openAside && <div onClick={()=>setOpenAside(false)} className='overlay'></div>}
        <aside className={openAside?"open":""}> 
            <button id='btn-close' onClick={()=>setOpenAside(false)}><img src='/assets/icons/angle-down.png'/></button>
            {nav()}
        </aside>

        <div id={"main"}>
        {React.Children.map(children, (child, index) => {
        return React.cloneElement(child, {
          ref: (el) => (sectionsRef.current[index] = el), // Adiciona ref a cada seção
          
          scrollToNextSection: () => scrollToNextSection(index)
        });
      })}
        </div>
        </>
    )
}

export default Header;